module.exports = __webpack_public_path__ + "img/glasses_female_square_mask.1d898c93.png";